import { render, staticRenderFns } from "./StudentInviteOnboarding.vue?vue&type=template&id=529932b1&"
import script from "./StudentInviteOnboarding.vue?vue&type=script&lang=js&"
export * from "./StudentInviteOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports